/**
 * logic_apply  报名信息
 * @Author scepter
 * @Date 2020-09-01
 */


/**
 * 添加
 * @param {*} that
 */
function rqSave(that){
    that.form.validateFields((err, values) => {
        if (!err) {
            let tehl=that.tehdata.length;
            if(tehl==0){
                that.$message.warning("指导教师的人数最少1人次！");
                return false;
            }
            let stul=that.studata.length;
            if(stul<2){
                that.$message.warning("参赛人员的人数最少2人次！");
                return false;
            }
            let islexit=false;
            let dataList=that.studata;
            for(let i=0;i<dataList.length;i++){
                if(dataList[i].isLader=='队长'){
                    islexit=true;
                }
            }
            if(!islexit){
                that.$message.warning("参赛人员必须存在一名队长！");
                return false;
            }
            that.loading=true;
            that.post(that.formConfig.saveUrl,Object.assign(values,{stuList:that.studata,tehList:that.tehdata}),true).
            then(res => {
                if(res.result){
                    that.loading=false;
                    that.$message.success(res.msg);
                    //清空数据内容
                    that.form.resetFields();
                    //关闭form表单
                    that.formClose();
                    //让列表带着查询刷新
                    that.formConfig.tableSearch('search');
                }else{
                    that.loading=false;
                    that.$message.warning(res.msg);
                }
            }).catch(error => {
                that.loading=false;
                that.$message.error('请联系系统管理员!');
            })
        }
    });
}

/**
 * 更新
 * @param {} that
 */
function rqEdit(that){
    that.form.validateFields((err, values) => {
        if (!err) {
            let tehl=that.tehdata.length;
            if(tehl==0){
                that.$message.warning("指导教师的人数最少1人次！");
                return false;
            }
            let stul=that.studata.length;
            if(stul<2){
                that.$message.warning("参赛人员的人数最少2人次！");
                return false;
            }
            that.loading=true;
            that.post(that.formConfig.editUrl,Object.assign(values,{id:that.params.id,stuList:that.studata,tehList:that.tehdata}),true).
            then(res => {
                if(res.result){
                    that.loading=false;
                    that.$message.success(res.msg);
                    //清空数据内容
                    //that.form.resetFields();
                    //关闭form表单
                    that.formClose();
                    //让列表带着查询刷新
                    that.formConfig.tableSearch('search');
                }else{
                    that.loading=false;
                    that.$message.warning(res.msg);
                }
            }).catch(error => {
                that.loading=false;
                that.$message.error('请联系系统管理员!');
            })
        }
    });
}

/**
 * 删除
 * @param {} that
 * @param {*} id
 */
function rqDel(that,id){
    if(id instanceof Array){
        var ids="'-1'";
        for(var value of id){
            ids+="',"+value+"'"
        }
    }else{
        ids="'"+id+"'";
    }
    that.loading=true;
    that.post(that.formConfig.delUrl,{id:ids},true).
    then(res => {
        if(res.result){
            that.$message.success(res.msg);
            that.loading=false;
            //让列表带着查询刷新
            that.formConfig.tableSearch('search');
        }else{
            that.loading=false;
            that.$message.warning(res.msg);
        }
    }).catch(error => {
        that.loading=false;
        that.$message.error('请联系系统管理员!');
    })
}

/**
 * 查看
 * @param {} that
 */
function rqForm(that){
    that.loading=true;
    that.post(that.formConfig.formUrl,{id:that.params.id},true).
    then(res => {
        if(res.result){
            that.$message.success(res.msg);
            that.form.setFieldsValue(res.object);
            that.studata=res.object.stuList;
            that.tehdata=res.object.tehList;
            that.loading=false;
        }else{
            that.loading=false;
            that.$message.warning(res.msg);
        }
    }).catch(error => {
        that.loading=false;
        that.$message.error('请联系系统管理员!');
    })
}

/**
 * 获取学校信息
 * @param {} that
 */
function getSchool(that){
    that.loading=true;
    that.get(that.formConfig.getSchoolUrl,{},true).
    then(res => {
        if(res.result){
            // console.log(res.object)
            //that.$message.success(res.msg);
            that.schoolList=res.object;
            that.loading=false;
        }else{
            that.loading=false;
            that.$message.warning(res.msg);
        }
    }).catch(error => {
        that.loading=false;
        that.$message.error('请联系系统管理员!');
    })
}

/**
 * 导出
 * @param {} that
 */
function rqExport(that){
    that.$message.loading('正在导出请稍等...您可以先操作其他功能！',3.21);
    let params={};
    that.searchForm.validateFields((err, values) => {
        if (null==err) {
            params=Object.assign({},values,{createDateStart:that.createDateStart,createDateEnd:that.createDateEnd});
        }
    });
    //that.$refs.oTable.loading = true
    that.post(that.formConfig.exportUrl,Object.assign(params,{excelTitle:"报名信息"}),true,'blob').
    then(res => {
        try{
            let blob = res;
            let reader = new FileReader()
            reader.readAsDataURL(blob)
            reader.onload = (e) => {
                //下载题目
                let a = document.createElement('a')
                // download属性
                a.setAttribute('download', '分析报表')
                // href链接
                a.setAttribute('href', e.target.result)
                a.setAttribute('target', '_blank')
                a.click()
                document.body.removeChild(a)
                //that.$refs.oTable.loading = false
            }
        }catch(err){
            that.$refs.oTable.loading = false
            that.$message.error('导出错误!');
        }
    }).catch(error => {
        that.$refs.oTable.loading = false
        that.loading=false;
        that.$message.error('请联系系统管理员!');
    })
}

function formFile (that, applyId) {
    //that.$refs.oTable.loading = true
    const params = { applyId, type: "1" }
    that.post('/logicFileEntity/formFile', params).then(res => {
        //that.$refs.oTable.loading = false
        if(res.result){
            if(res.object === null) {
                that.$message.warning('暂无案例分析报告！');
            } else {
                const { title, fileUrl } = res.object
                that.visible = true
                that.reportForm.title = title
                that.reportForm.fileUrl = fileUrl
            }
        }else{
            that.$message.warning(res.msg);
        }
    }).catch(error=>{
        that.$refs.oTable.loading = false
        that.$message.error('请联系系统管理员!');
    })
}

function postAnalysis(that, formData) {
    that.loading=true;
    that.post('/logicFileEntity/save',formData,true).
    then(res => {
        if(res.result){
        //console.log(res.object)
        that.$message.success(res.msg);
        that.loading=false;
        }else{
        that.loading=false;
        that.$message.warning(res.msg);
        }
        that.$emit('changeVisible')
    }).catch(error => {
        that.loading=false;
        that.$message.error('请联系系统管理员!');
    })
}

function getAnalysis (that, formData) {  
    that.loading=true;
    that.post('/logicFileEntity/formFile',formData,true).
    then(res => {
        if(res.result){
        //console.log(res.object)
        //that.$message.success(res.msg);
        that.loading=false;
        that.$nextTick(()=>{
            that.analysis_report_form.setFieldsValue({
                title: res.object.title,
                id: res.object.id,
            })
            that.analysis_report_form_fileUrl = res.object.fileUrl
        })

        }else{
        that.loading=false;
        that.$message.warning(res.msg);
        }
    }).catch(error => {
        that.loading=false;
        that.$message.error('请联系系统管理员!');
    })
}

/**
 * 晋级操作
 * @param {} that
 */
function promotionOper(that,id,status){
    that.loading=true;
    that.post(that.formConfig.promotionUrl,{id:id,status:status},true).
    then(res => {
        if(res.result){
            that.loading=false;
            //让列表带着查询刷新
            that.formConfig.tableSearch('search');

        }else{
            that.loading=false;
            that.$message.warning(res.msg);
        }
    }).catch(error => {
        that.loading=false;
        that.$message.error('请联系系统管理员!');
    })
}
   
export {
    rqSave,
    rqEdit,
    rqDel,
    rqForm,
    getSchool,
    rqExport,
    formFile,
    postAnalysis,
    getAnalysis,
    promotionOper
}   
    

